import { setLocation } from 'utils/wrappers';
import Session from 'app/models/session';

import Base from 'app/views/base';
import tmpl from 'templates/basic_navbar';

const { EasyPost } = global;

export default Base.extend({
  compiledTemplate: tmpl,

  initialize() {
    // TODO: on any of the docs/header pages, use UserNavView and put the dashboard button at the
    // top of that list of items.
    this.listenTo(this.model, 'sync', this.render);
  },

  context() {
    return {
      loggedIn: this.model.isLoggedInAllowUnverified(),
      email: this.model.get('email'),
    };
  },

  signOut(e) {
    e.preventDefault();
    new Session({ id: 'deleteme' }).destroy({
      success() {
        setLocation('/');
      },
      error() {
        EasyPost.Globals.currentUser.fetch({
          error() {
            setLocation('/');
          },
        });
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/views/basic_navbar_view.js